import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { WorkStations } from "../workstations/workstations.entity";

@Entity('workstation_categories')
export class WorkstationCategories {

  @PrimaryGeneratedColumn("increment",{name:'workstation_category_id'})
  workstationCategoryId:number;
  
  @Column("varchar",{
      nullable:false,
      length:50,
      name:"workstation_category"
      })
  @Index({unique:true})
  workstationCategory:string;

  @Column("boolean",{
    nullable:false,
    default:true,
    name:"is_active"
    })
  isActive:boolean;

  @CreateDateColumn({
    name: "created_at",
    type:"datetime"
  })
  createdAt: Date;

  @Column("varchar", {
      nullable: false,
      name: "created_user",
      length:50
  })
  createdUser: string | null;


  @UpdateDateColumn({
      name: "updated_at",
      type:'datetime'
  })
  updatedAt: Date;

  @Column("varchar", {
      nullable: true,
      name: "updated_user",
      length:50
  })
  updatedUser: string | null;

  @VersionColumn({
      default:1,
      name: "version_flag"
  })
  versionFlag: number;

  @OneToMany(type => WorkStations, category => category.workstationCategoryInfo)
  workstationInfo: WorkStations[];
}
